module.exports = __webpack_public_path__ + "img/HPS016CP.fb11f643.png";